// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Moved ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' action completed',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' action in progress',
  accColorPalette: () => 'Color Palette',
  accColorSwatch: () => 'Color Swatch',
  accCommandKey: () => 'Command',
  accContextMenuLabel: () => 'actions',
  accControlKey: () => 'Close',
  accPositionAfter: () => 'after',
  accPositionBefore: () => 'before',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Press and hold ' + p['keyPressed'] + ' and shift keys, then use the arrow keys to reorder.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Enter a complete date like this: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Enter a month and year like this: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Label',
  chart_labelGroup: () => 'Group',
  chart_labelSeries: () => 'Series',
  chart_labelValue: () => 'Value',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Select a value.',
  checkbox_helpForCheckbox: () => 'Help for checkbox',
  checkbox_requiredMessageDetail: () => 'Select a value.',
  checkbox_selected: () => 'Checkbox checked',
  checkbox_unselected: () => 'Checkbox not checked',
  close: () => 'Close',
  collection_apply: () => 'Apply',
  collection_cancel: () => 'Cancel',
  collection_loaded: () => 'Loaded',
  collection_loading: () => 'Loading',
  collection_noData: () => 'No data to display.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Resize column',
  collection_resizeColumnMenu: () => 'Resize Column...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Enter a number between ' + p['MIN'] + ' and ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Select all rows',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Select row ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Ascending',
  collection_sortColumnMenu: () => 'Sort Column',
  collection_sortDescendingSubMenu: () => 'Descending',
  collection_sortDisabled: () => 'Not sortable',
  collection_sortEnabled: () => 'Sortable',
  collection_width: () => 'Width',
  colorPicker_label: () => 'Color Picker',
  confirmation: () => 'Confirmation',
  datePicker_currentDate: () => 'Current date',
  datePicker_goToToday: () => 'Go to today',
  datePicker_label: () => 'Date Picker',
  datePicker_month: () => 'Month',
  datePicker_months: () => 'Months',
  datePicker_next: () => 'Next',
  datePicker_nextDecade: () => 'Next decade',
  datePicker_nextMonth: () => 'Next month',
  datePicker_prev: () => 'Previous',
  datePicker_prevDecade: () => 'Previous decade',
  datePicker_prevMonth: () => 'Previous month',
  datePicker_restricted: () => 'Restricted',
  datePicker_selected: () => 'Selected',
  datePicker_today: () => 'Today',
  datePicker_weekNum: (p: { NUM: string }) => 'Week ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Week Number',
  datePicker_year: () => 'Year',
  datePicker_years: () => 'Years',
  diagram_promotedLink: () => '1 link',
  diagram_promotedLinkAriaDesc: () => 'Indirect',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' links',
  error: () => 'Error',
  expandableList_expandCollapseInstructionText: () => 'Use arrow keys to expand and collapse',
  expandableList_groupCollapse: () => 'Collapsed',
  expandableList_groupExpand: () => 'Expanded',
  filePicker_addFiles: () => 'Add Files',
  filePicker_dropzonePrimaryText: () => 'Drag and Drop',
  filePicker_dropzoneSecondaryText: () => 'Select a file or drop one here',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Select or drop files here',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "You can't upload files of type: " + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Upload one file at a time',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "You can't upload files of type " + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'unknown',
  formControl_clear: () => 'Clear',
  formControl_day: () => 'Day',
  formControl_empty_segment: () => 'Empty',
  formControl_helpAvailable: () => 'Help available',
  formControl_hide: () => 'Hide',
  formControl_hour: () => 'Hour',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'You’ve reached the ' +
    ((
      { one: new Intl.NumberFormat('en').format(p['CHARACTER_LIMIT']) + '-character' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('en').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('en').format(p['CHARACTER_LIMIT']) + '-character') +
    ' limit.',
  formControl_loading: () => 'Loading',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'You can enter up to ' + p['MAX_LENGTH'] + ' characters.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximum length ' + p['MAX_LENGTH'] + ' exceeded.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' characters left.',
  formControl_millisecond: () => 'Millisecond',
  formControl_minute: () => 'Minute',
  formControl_month: () => 'Month',
  formControl_readOnly: () => 'Read only',
  formControl_requiredMessageDetail: () => 'Enter a value.',
  formControl_second: () => 'Second',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Select ' + p['n'] + ' values.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'You’ve reached the ' + p['max'] + '-selection limit.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Select ' + p['min'] + ' to ' + p['max'] + ' values.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Select at least ' + p['min'] + ' values.',
  formControl_show: () => 'Show',
  formControl_year: () => 'Year',
  gantt_labelDate: () => 'Date',
  gantt_labelEnd: () => 'End',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Row',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. No matching section found.',
  indexer_keyboardInstructionText: () => 'Press enter to select value.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Double tap and hold to enter gesture mode, then drag up or down to adjust value.',
  info: () => 'Info',
  inputColor_selectColor: () => 'Select a color',
  inputDateMask_date_cleared: () => 'Date cleared',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Empty',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "Enter a date that's on or before " + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "Enter a date that's on or after " + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Enter an available date.',
  inputDatePicker_instruction: () => 'Press Tab to access the calendar.',
  inputDatePicker_selectDate: () => 'Select a date',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "Enter a month and year that's on or before " + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "Enter a month and year that's on or after " + p['min'] + '.',
  inputNumber_converterParseError: () => 'Enter a number.',
  inputNumber_decrease: () => 'Decrease',
  inputNumber_increase: () => 'Increase',
  inputPassword_hidden: () => 'Password Hidden',
  inputPassword_hide: () => 'Hide Password',
  inputPassword_show: () => 'Show Password',
  inputSensitiveText_hidden: () => 'Sensitive text hidden',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    "Enter a time that's " + p['max'] + ' or earlier.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    "Enter a time that's " + p['min'] + ' or later.',
  inputTimeMask_time_cleared: () => 'Time cleared',
  labelNone: () => 'None',
  list_msgFetchCompleted: () => 'Loaded',
  list_msgFetchingData: () => 'Loading',
  list_suggestion: () => 'Suggestion',
  menu_stateLoading: () => 'Loading',
  messageToast_allMessagesClosed: () => 'All toast messages are closed.',
  message_close: () => 'Close',
  message_confirmation: () => 'Success',
  message_error: () => 'Error',
  message_info: () => 'Info',
  message_navigationFromMessagesRegion: () => 'Entering messages region. Press F6 to navigate.',
  message_navigationToMessagesRegion: () =>
    'Messages region has new messages. Press F6 to navigate.',
  message_navigationToTouch: () => 'Messages region has new messages.',
  message_warning: () => 'Warning',
  noData_message: () => 'No items to display',
  overflowItemLabel: () => 'More Tabs',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Double tap to close the open pop-up.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Entering pop-up. Press F6 to navigate between the pop-up and associated control.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Pop-up opened. Press F6 to navigate between the pop-up and associated control.',
  progressIndeterminate: () => 'In Progress',
  radioButton_checked: () => 'Radio button checked',
  radioButton_selected: () => 'Radio button selected',
  radioButton_unchecked: () => 'Radio button not checked',
  radioButton_unselected: () => 'Radio button not selected',
  radio_helpForRadio: () => 'Help for radio button',
  radio_requiredMessageDetail: () => 'Select a value.',
  selectMultiple_apply: () => 'Apply',
  selectMultiple_back: () => 'Back',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Use left and right arrow keys to highlight selected values.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Press Backspace or Delete to remove the selected value.',
  selectMultiple_selectedValues: () => 'Selected values',
  selectMultiple_showSelectedValues: () => 'Show selected values only.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' values selected.',
  select_addToList: () => 'Add to list',
  select_addToListAvailable: () => 'Add to list available',
  select_closeDropdown: () => 'Press Escape to close.',
  select_moreSearchOptions: () => 'More search options',
  select_moreSearchOptionsAvailable: () => 'More search options available',
  select_noMatchesFound: () => 'No matches found.',
  select_oneMatchFound: () => 'One match found',
  select_requiredMessageDetail: () => 'Select a value.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches found',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' or more matches found',
  selectorAll_deselectAll: () => 'Deselect all',
  selectorAll_selectAll: () => 'Select all',
  selector_selected: () => 'Checkbox checked',
  selector_unselected: () => 'Checkbox not checked',
  sheet_close: () => 'Close',
  switch_off: () => 'Off',
  switch_on: () => 'On',
  tabBarNavigationList_removeCueText: () => 'Removable',
  tabBar_tabContainsErrors: () => 'Contains errors',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Removed ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'has context menu',
  tabbar_labelMoveLeft: () => 'Move Left',
  tabbar_labelMoveRight: () => 'Move Right',
  tabbar_labelRemove: () => 'Remove',
  timeComponent_tooltipZoomIn: () => 'Zoom In',
  timeComponent_tooltipZoomOut: () => 'Zoom Out',
  timeConverter_parseError: () => 'Enter a complete time.',
  train_current: () => 'Current',
  train_message_type: () => 'Message Type',
  train_not_visited: () => 'Not visited',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Step ' + p['currentStep'] + ' out of ' + p['numberOfSteps'],
  train_visited: () => 'Visited',
  userAssistance_learnMore: () => 'Learn more',
  userAssistance_required: () => 'Required',
  vis_clearSelection: () => 'Clear Selection',
  vis_drillable: () => 'Drillable',
  vis_invalidData: () => 'Invalid data',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' out of ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Marquee select',
  vis_marqueeZoomTooltip: () => 'Marquee zoom',
  vis_noData: () => 'No data to display',
  vis_panTooltip: () => 'Pan',
  vis_stateCollapsed: () => 'Collapsed',
  vis_stateExpanded: () => 'Expanded',
  vis_stateLoaded: () => 'Loaded',
  vis_stateLoading: () => 'Loading',
  vis_stateSelected: () => 'Selected',
  vis_stateUnselected: () => 'Unselected',
  warn: () => 'Warning'
};
export default bundle;
export type BundleType = typeof bundle;
